<template></template>
<script>
export default {
    name        :   'PaginationMixin',
    data()
    {
        return {
            page    :   this.$route.query.page ? parseInt(this.$route.query.page) : 0,
        }
    },
    computed    :   {
        page_left() {
            return this.site_data.result.pages - this.page;
        },
        pagination() {
            let pagination  =   [];
            if (this.site_data.result.pages > 5) {
                if (this.page < 4) {
                    for (let i = 0; i < 5; i++) {
                        pagination.push({
                            label   :   i + 1,
                            index   :   i
                        });
                    }
                    pagination.push({
                        index   :   null
                    });
                    pagination.push({
                        label   :   this.site_data.result.pages,
                        index   :   this.site_data.result.pages - 1
                    });
                } else {
                    pagination.push({
                        label   :   1,
                        index   :   0
                    });

                    pagination.push({
                        index   :   null
                    });

                    if (this.page_left > 2) {
                        for (let i = 2; i > 0; i--) {
                            pagination.push({
                                label   :   this.page - i + 1,
                                index   :   this.page - i
                            });
                        }
                    }

                    if (this.page_left > 3) {
                        for (let i = 0; i < 3; i++) {
                            pagination.push({
                                label   :   this.page + i + 1,
                                index   :   this.page + i
                            });
                        }

                        if (this.page_left > 4) {
                            pagination.push({
                                index   :   null
                            });
                        }

                        pagination.push({
                            label   :   this.site_data.result.pages,
                            index   :   this.site_data.result.pages - 1
                        });
                    } else {
                        if (this.page_left < 3) {
                            for (let i = 5; i > 3; i--) {
                                pagination.push({
                                    label   :   this.site_data.result.pages - i + 1,
                                    index   :   this.site_data.result.pages - i
                                });
                            }
                        }
                        for (let i = 3; i > 0; i--) {
                            pagination.push({
                                label   :   this.site_data.result.pages - i + 1,
                                index   :   this.site_data.result.pages - i
                            });
                        }
                    }
                }
            } else {
                for (let i = 0; i < this.site_data.result.pages; i++) {
                    pagination.push({
                        label   :   i + 1,
                        index   :   i
                    });
                }
            }

            return pagination;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/PaginationMixin.vue